export const chipTokens = {
  inactiveBgAlpha: 0.16,
  inactiveHoverBgAlpha: 0.24,
  inactiveBorderAlpha: 0.24,
  inactiveHoverBorderAlpha: 0.32,
  selectedBorderAlpha: 0.48,
} as const

export type ChipTokens = typeof chipTokens
